import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Helmet } from 'react-helmet';
import { EVENT_NAME } from 'appenv';
import { useSelector } from 'react-redux';
import { selectExhibitorsByKeyword } from 'models/exhibitors';
import { selectWebinarsByKeyword } from 'models/webinars';

import XtraAppBar from '../../components/appbar/XtraAppBar';
import Footer from '../../components/Footer';
import useURLSearchParams from '../../hooks/useURLSearchParams';
import ExhibitorItem from './ExhibitorItem';
import WebinarItem from './WebinarItem';
import EmptyStateImg from '../../assets/search-empty-state.svg';

const RootContainerUI = styled.div`
  height: 100%;
  overflow: auto;
`;

function RootContainer({ children }) {
  return (
    <RootContainerUI>
      {children}
    </RootContainerUI>
  );
}

RootContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const PageContentContainer = styled.div`
  max-width: 800px;
  padding-top: 16px;
  margin: auto;
`;

const TitleContainer = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #A2AAB3;
`;

const EmptyStateContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 70px;
`;

const EmptyStateText = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  color: #484848;
  padding: 24px;
`;

const SearchResultContainer = () => {
  const query = useURLSearchParams();
  const searchText = query.get('searchText');

  const exhibitors = useSelector(selectExhibitorsByKeyword(searchText));

  const webinars = useSelector(selectWebinarsByKeyword(searchText));

  const matchedSearchResult = {
    exhibitors,
    webinars,
  };
  const locale = 'en';

  return (
    <RootContainer>
      <XtraAppBar />
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Search Results | ${EVENT_NAME}`}</title>
        <meta name="description" content={`Search results for booths in ${EVENT_NAME}.`} />
      </Helmet>
      <PageContentContainer>
        <TitleContainer>
          {
            `Search result of "${searchText}"`
          }
        </TitleContainer>
        {
          (matchedSearchResult.exhibitors && matchedSearchResult.exhibitors.length > 0) || (matchedSearchResult.webinars && matchedSearchResult.webinars.length > 0) ? (
            <>
              {
                matchedSearchResult.exhibitors.map((exhibitor) => {
                  const { name, description } = exhibitor.translations[locale] || {};

                  return (
                    <ExhibitorItem
                      key={exhibitor.id}
                      id={`${exhibitor.id}`}
                      name={name}
                      details={description}
                    />
                  );
                })
              }
              {
                matchedSearchResult.webinars.map((webinar) => {
                  const { title, description, speakers } = webinar.translations[locale] || {};

                  return (
                    <WebinarItem
                      key={webinar.id}
                      name={title}
                      details={description}
                      speakers={speakers}
                    />
                  );
                })
              }
            </>
          ) : (
            <EmptyStateContainer>
              <img src={EmptyStateImg} alt="No Results" />
              <EmptyStateText>
                Sorry, no results found :(
              </EmptyStateText>
            </EmptyStateContainer>
          )
        }
        <Footer />
      </PageContentContainer>
    </RootContainer>
  );
};

export default SearchResultContainer;
